/*
 *   File : manage-basket.js
 *   Author : https://evoqins.com
 *   Description : manage basket component
 *   Integrations : manage-basket/list
 *   Version : 2.0.0
 */

import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { setPageTitle, setSearchEnabled } from "../../Redux/Ui/ui.slice";
import { PrimaryButton } from "../../Components/Buttons";
import { BasketCard } from "../../Components/Cards";
import { useNavigate } from "react-router-dom";
import { EmptyScreen, Loader } from "../../Components/Other";
import { APIService } from "../../Service";
import { Tabs } from "../../Components/Navigation";
import { BasketConfig } from "./Helper";

const TAB_DATA = [
  { id: 0, label: "liveBaskets", name: "Live baskets" },
  { id: 1, label: "predefinedBaskets", name: "Pre-Defined baskets" },
];

export default function ManageBasket() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [loader, setLoader] = useState(false);
  const [isEmpty, setIsEmpty] = useState(false);
  const [baskets, setBaskets] = useState([]);
  const [curTab, setCurTab] = useState(0);

  useEffect(() => {
    _getBaskets();
    dispatch(setPageTitle(["Manage Basket"]));
    dispatch(setSearchEnabled(false));
  }, []);

  /* ----------------------------------------
      API
  ---------------------------------------- */
  const mapApiToOption = (item) => {
    const cagr =
      item.return_percentage === "--" || item.return_percentage === null
        ? null
        : Number(item.return_percentage);

    return {
      id: item.basket_style_id,
      img: item.image,
      title: item.name,
      CAGR: cagr,
      best_for: item.best_for || item.return_year || "",
      risk: item.risk || "",
      raw: item,
    };
  };

  const _getBaskets = () => {
    setLoader(true);
    APIService(false, "manage-basket/list")
      .then((res) => {
        if (res.status_code === 200 && Array.isArray(res.data)) {
          setBaskets(res.data.map(mapApiToOption));
          setIsEmpty(res.data.length === 0);
        } else {
          setBaskets([]);
          setIsEmpty(true);
        }
      })
      .catch(() => {
        setBaskets([]);
        setIsEmpty(true);
      })
      .finally(() => setLoader(false));
  };

  /* ----------------------------------------
      RENDER
  ---------------------------------------- */
  if (loader) return <Loader />;

  return (
    <div className="d-flex flex-column row-gap-3 pt-3">
      <div className="d-flex justify-content-end">
        <PrimaryButton
          name={"Add Basket"}
          ClassName={
            "bg-oxford-blue fw-400 fs-16 lh-24 text-white rounded-16 py-2 px-3"
          }
          onPress={() => navigate("/manage-basket/add")}
        />
      </div>

      {isEmpty ? (
        <EmptyScreen message={"No Baskets found"} />
      ) : (
        <div className="d-flex flex-column e-glass-card rounded-24 shadow-none p-24 bg-transparent row-gap-3">
          <Tabs
            data={TAB_DATA}
            defaultActive={curTab}
            onChange={(activeId) => setCurTab(activeId)}
          />

          {curTab === 0 ? (
            /* ---- Live Baskets grid ---- */
            <div className="row row-cols-3 row-gap-3">
              {baskets.map((basket, i) => (
                <div key={i} className="col">
                  <BasketCard data={basket} />
                </div>
              ))}
            </div>
          ) : (
            <div className="row">
              <div className="col-lg-10 col-12">
                <BasketConfig />
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
}
